import { useCallback, useEffect, useState } from 'react';

export const breakpoints = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1400,
};

export function useBreakpoints(size, mode = 'down') {
    const [satisfy, setSatisfy] = useState(false);

    if (!Object.values(breakpoints).includes(size)) {
        throw new Error('Wrong breakpoints given.');
    }

    const handleResize = useCallback(() => {
        if (mode === 'up') {
            setSatisfy(window.innerWidth >= size);

            return;
        }
        // Considering down mode as fallback
        setSatisfy(window.innerWidth < size);
    }, [size, mode]);

    useEffect(() => {
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [size, handleResize]);

    return satisfy;
}
